import { render, staticRenderFns } from "./AsStampStatus.vue?vue&type=template&id=d8b55134"
import script from "./AsStampStatus.vue?vue&type=script&lang=js"
export * from "./AsStampStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports